import { InjectionToken } from '@angular/core';

export const ADDITIONAL_AUTOCOMPLETER_QUERY_PARAMS = new InjectionToken<Record<string, any>>(
    'autocompleter additional query params'
);
